<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap');

.container-card-items {
    min-height: 20vh;
    width: 100%;
    background: #f3f4f7;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding-bottom: 30px;
    padding-top: 30px;
    border-radius: 15px;
}

.container-card-items form {
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, .1);
    padding: 20px;
    width: 600px;
    padding-top: 140px;
}

.container-card-items form .inputBox {
    margin-top: 20px;
    font-size: 14px;
}

.container-card-items form .inputValue {
    margin-top: 20px;
    font-size: 14px;
}

.container-card-items form .inputValue input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, .3);
    color: #0C5A9D;
    display: flex;
}

.container-card-items form .inputBox span {
    display: block;
    color: #0C5A9D;
    padding-bottom: 5px;
}

.container-card-items form input,
.container-card-items form select {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, .3);
    color: #0C5A9D;
}

.container-card-items form .flexbox {
    display: flex;
    gap: 15px;

}

.container-card-items form .flexbox .inputBox {
    flex: 1 1 150px;
}

.container-card-items form .submit-btn {
    width: 100%;
    background: linear-gradient(45deg, #074275, #0574d4);
    margin-top: 20px;
    padding: 10px;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
    transition: .2s linear;
    border: linear-gradient(45deg, #074275, #0574d4) 2px solid;
}

.container-card-items form .submit-btn:hover {
    opacity: .8;
}

.container-card-items .card-container {
    margin-bottom: -120px;
    position: relative;
    height: 250px;
    width: 400px;
}

    .container-card-items .card-container .front {
        font-family: 'Open Sans', sans-serif;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 20px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

.container-card-items .card-container .front .image {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
}

.container-card-items .card-container .front .image img {
    height: 50px;
}

.container-card-items .card-container .front .card-number-box {
    padding: 30px;
    font-size: 22px;
    color: #fff;
}

.container-card-items .card-container .front .flexbox {
    display: flex;
}

.container-card-items .card-container .front .flexbox .box:nth-child(1) {
    margin-right: auto;
}

.container-card-items .card-container .front .flexbox .box {
    font-size: 15px;
    color: #fff;
}

.container-card-items .card-container .back {
    font-size: 'Source Code Pro';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(45deg, #052f55, #0574d4);
    border-radius: 15px;
    padding: 20px 0;
    text-align: right;
    backface-visibility: hidden;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
    transform: perspective(1000px) rotateY(180deg);
    transition: transform .4s ease-out;
    background: no-repeat center center fixed;
}

.container-card-items .card-container .back .stripe {
    background: #141414;
    width: 100%;
    margin: 10px 0;
    height: 50px;
}

.container-card-items .card-container .back .box {
    padding: 0 20px;
}

.container-card-items .card-container .back .box span {
    color: #fff;
    font-size: 15px;
}

.container-card-items .card-container .back .box .cvv-box {
    height: 50px;
    padding: 10px;
    margin-top: 5px;
    color: #333;
    background: #fff;
    border-radius: 5px;
    width: 100%;
}

.container-card-items .card-container .back img {
    margin-top: 30px;
    height: 30px;
}

@media (max-width: 750px) {

    .container-card-items form {
        padding: 18px;
        width: 550px;
        padding-top: 140px;
    }

    .container-card-items form .inputBox {
        margin-top: 18px;
        font-size: 12px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 12px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 9px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 9px;
    }


    .cart-table-data>td {
        font-size: 14px;
    }

    .container-card-items form .submit-btn {
        font-size: 14px;
        padding: 8px;
    }

}

@media (max-width: 650px) {

    .container-card-items form {
        padding: 18px;
        width: 500px;
        padding-top: 140px;
    }

    .container-card-items form .inputBox {
        margin-top: 18px;
        font-size: 11px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 11px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 8px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 8px;
    }


    .cart-table-data>td {
        font-size: 13px;
    }

    .container-card-items form .submit-btn {
        font-size: 13px;
        padding: 7px;
    }

    /* Cartão */

    .container-card-items .card-container {
        margin-bottom: -135px;
        position: relative;
        height: 200px;
        width: 350px;
    }

    .container-card-items .card-container .front {
        font-size: 'Source Code Pro';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 16px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .front .image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
    }

    .container-card-items .card-container .front .image img {
        height: 25px;
        width: 20px;
    }

    .container-card-items .card-container .front .card-number-box {
        padding: 20px;
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .front .flexbox {
        display: flex;
    }

    .container-card-items .card-container .front .flexbox .box:nth-child(1) {
        margin-right: auto;
    }

    .container-card-items .card-container .front .flexbox .box {
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .back {
        font-size: 'Source Code Pro';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(45deg, #052f55, #0574d4);
        border-radius: 15px;
        padding: 16px 0;
        text-align: right;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
        transform: perspective(1000px) rotateY(180deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .back .stripe {
        background: #141414;
        width: 100%;
        margin: 10px 0;
        height: 40px;
    }

    .container-card-items .card-container .back .box {
        padding: 0 18px;
    }

    .container-card-items .card-container .back .box span {
        color: #fff;
        font-size: 12px;
    }

    .container-card-items .card-container .back .box .cvv-box {
        height: 40px;
        padding: 10px;
        margin-top: 5px;
        color: #333;
        background: #fff;
        border-radius: 5px;
        width: 100%;
    }

    .container-card-items .card-container .back img {
        margin-top: 20px;
        height: 30px;
    }

}

@media (max-width: 550px) {

    .container-card-items form {
        padding: 18px;
        width: 400px;
        padding-top: 150px;
    }

    .container-card-items form .inputBox {
        margin-top: 14px;
        font-size: 11px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 10px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 7px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 7px;
    }


    .cart-table-data>td {
        font-size: 12px;
    }

    .container-card-items form .submit-btn {
        font-size: 12px;
        padding: 6px;
    }

    /* Cartão */

    .container-card-items .card-container {
        margin-bottom: -135px;
        position: relative;
        height: 150px;
        width: 250px;
    }

    .container-card-items .card-container .front {
        font-size: 'Source Code Pro';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 16px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
        background-size: 400px;
    }

    .container-card-items .card-container .front .image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
    }

    .container-card-items .card-container .front .image img {
        margin-top: 10px;
        height: 28px !important;
        width: 42px !important;
    }

    .container-card-items .card-container .front .card-number-box {
        padding: 8px;
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .front .flexbox {
        display: flex;
    }

    .container-card-items .card-container .front .flexbox .box:nth-child(1) {
        margin-right: auto;
    }

    .container-card-items .card-container .front .flexbox .box {
        font-size: 10px;
        color: #fff;
    }

    .container-card-items .card-container .back {
        font-size: 'Source Code Pro';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(45deg, #052f55, #0574d4);
        border-radius: 15px;
        padding: 16px 0;
        text-align: right;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
        transform: perspective(1000px) rotateY(180deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .back .stripe {
        background: #141414;
        width: 100%;
        margin: 2px 0;
        height: 30px;
    }

    .container-card-items .card-container .back .box {
        padding: 0 18px;
    }

    .container-card-items .card-container .back .box span {
        color: #fff;
        font-size: 10px;
    }

    .container-card-items .card-container .back .box .cvv-box {
        height: 35px;
        padding: 8px;
        margin-top: 0px;
        color: #333;
        background: #fff;
        border-radius: 5px;
        width: 100%;
    }

    .container-card-items .card-container .back img {
        margin-top: 10px;
        height: 22px !important;
        width: 45px !important;
    }

    .cart-table-data>td {
        font-size: 10px;
    }

    .col-xs-12 {
        overflow: scroll;
    }


}

@media (max-width: 400px) {

    .container-card-items form {
        padding: 18px;
        width: 300px;
        padding-top: 150px;
    }

    .container-card-items form .inputBox {
        margin-top: 14px;
        font-size: 13px;
        width: 250px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 12px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 7px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 7px;
    }

    .container-card-items form .flexbox {
        display: unset;
    }

    .cart-table-data>td {
        font-size: 12px;
    }

    .container-card-items form .submit-btn {
        font-size: 10px;
        padding: 10px;
    }

    /* Cartão */

    .container-card-items .card-container {
        margin-bottom: -135px;
        position: relative;
        height: 150px;
        width: 250px;
    }

    .container-card-items .card-container .front {
        font-size: 'Source Code Pro';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 16px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
        background-size: 400px;
    }

    .container-card-items .card-container .front .image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
    }

    .container-card-items .card-container .front .image img {
        margin-top: 10px;
        height: 28px !important;
        width: 40px !important;
    }

    .container-card-items .card-container .front .card-number-box {
        padding: 8px;
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .front .flexbox {
        display: flex;
    }

    .container-card-items .card-container .front .flexbox .box:nth-child(1) {
        margin-right: auto;
    }

    .container-card-items .card-container .front .flexbox .box {
        font-size: 10px;
        color: #fff;
    }

    .container-card-items .card-container .back {
        font-size: 'Source Code Pro';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(45deg, #052f55, #0574d4);
        border-radius: 15px;
        padding: 16px 0;
        text-align: right;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
        transform: perspective(1000px) rotateY(180deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .back .stripe {
        background: #141414;
        width: 100%;
        margin: 2px 0;
        height: 30px;
    }

    .container-card-items .card-container .back .box {
        padding: 0 18px;
    }

    .container-card-items .card-container .back .box span {
        color: #fff;
        font-size: 10px;
    }

    .container-card-items .card-container .back .box .cvv-box {
        height: 35px;
        padding: 8px;
        margin-top: 0px;
        color: #333;
        background: #fff;
        border-radius: 5px;
        width: 100%;
    }

    .container-card-items .card-container .back img {
        margin-top: 10px;
        height: 22px !important;
        width: 45px !important;
    }

    .cart-table-data>td {
        font-size: 10px;
    }

    .col-xs-12 {
        overflow: scroll;
    }

}
</style>

<template>
    <main id="main" class="main-site">
        <div class="container" style="margin-bottom: 30px; margin-top: 30px;">
            <div class="col-md-12" style="margin-bottom: 25px; margin-top: 15px;">
                <a href="https://www.aldo.com.br/loja">
                    <img src="/assets/images/calculadora-solar/logo-aldo-solar.jpg" width="180" alt="Aldo Solar">
                </a>
            </div>
            <div v-if="mostrarInfoPedido">
                <div class="row">
                    <h3 class="text-center">
                        <strong>
                            DETALHES DO PAGAMENTO
                        </strong>
                    </h3>
                </div>
                <div class="row">
                    <h4 class="text-center">
                        Bem vindo, {{ nomeDoCliente }}.
                    </h4>
                </div>
                <br />
                <hr class="row" width="max" style="border-width: 1px;" />
                <div class="row" style="color: #0C5A9D;">
                    <div class="col-md-12 text-center" style="margin-bottom: 25px;">
                        <h4>
                            PEDIDO
                        </h4>
                        <h4 style="color: black;">
                            {{ pedido.codigo }}-{{ pedido.codigodv }}
                        </h4>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Revenda
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.nomeDaRevenda }}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Vendedor
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.nomeDoVendedor }}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Data do pedido
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.dataDoPedido }}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Cidade
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.cidadeUfDoPedido }}
                                </h6>
                            </div>
                        </div>

                    </div>
                    <br />
                    <hr class="row" width="max" style="border-width: 1px;" />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <table style="width:100%">
                                    <tr class="cart-table-header">
                                        <th class="text-center">Código</th>
                                        <th class="text-center">Foto</th>
                                        <th>Descrição</th>
                                        <th class="text-center">Qtde</th>
                                        <th class="text-center">Valor Unitário</th>
                                        <!--<th class="text-center"><i class="fa fa-exclamation-circle fa-lg" /></th>-->
                                    </tr>
                                    <tr class="cart-table-data" v-for="(product, index) in pedido.produtosDoPedido"
                                        :key="index">
                                        <td class="text-center">{{ product.codigo }}-{{ product.codigodv }}</td>
                                        <td class="text-center"><img class="cart-table-img" v-bind:src="product.img" /></td>
                                        <td>{{ product.subGrupo + " " + product.descricao }}</td>
                                        <td class="text-center">{{ product.quantidade }}</td>
                                        <td class="text-center">{{ converterParaReal(product.valorUnitario) }}</td>
                                        <!--<td class="text-center"><i class="fa fa-exclamation-circle fa-lg cart-product-info" style="color:#0083ca"><ProductTaxesTooltip :productTaxes="produtosDoPedido.taxes" :origin="produtosDoPedido.origin" /></i></td>-->
                                    </tr>
                                </table>
                                <div class="row">
                                    <div class="col-md-12" style="color:black;">
                                        <span class="cart-table-foot pull-right">Total: {{ pedido.totalFormatado }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section href="#" id="payment">
                        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 pagamento" style="padding: 15px">
                            <div class="col-lg12 col-sm-12 col-md-12 col-xs-12">
                                <div class="container-card-items">
                                    <div class="card-container">
                                        <div class="front"
                                            style="background-image: url(/assets/images/logo-bandeiras/KombiCard.jpeg);">
                                            <div class="image">
                                                <img src="/assets/images/logo-bandeiras/Chip.png"
                                                    style="height: 50px; width: 65px;" alt="">
                                                <div v-if="pedido.bandeiraCartao == 1">
                                                    <img style="height: 40px; width: 80px;"
                                                        src="/assets/images/logo-bandeiras/visa-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 2">
                                                    <img style="height: 50px; width: 65px;"
                                                        src="/assets/images/logo-bandeiras/mastercard-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 3">
                                                    <img style="height: 30px; width: 80px;"
                                                        src="/assets/images/logo-bandeiras/elo-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 4">
                                                    <img style="height: 35px; width: 75px;"
                                                        src="/assets/images/logo-bandeiras/hiper-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 5">
                                                    <img style="height: 30px; width: 85px;"
                                                        src="/assets/images/logo-bandeiras/amex-white.png" alt="">
                                                </div>
                                            </div>
                                            <div class="card-number-box" style=" margin-top: 10px;" v-if="cartaoDeCredito.numeroDoCartao !== ''">
                                                {{ cartaoDeCredito.numeroDoCartao }}</div>
                                            <div class="card-number-box" style=" margin-top: 10px;" v-else-if="cartaoDeCredito.numeroDoCartao === ''">
                                                0000
                                                0000 0000 0000</div>
                                            <div class="flexbox">
                                                <div class="box">
                                                    <span>Proprietário</span>
                                                    <div class="card-holder-name"
                                                        v-if="cartaoDeCredito.nomeImpressoNoCartao !== ''">
                                                        {{ cartaoDeCredito.nomeImpressoNoCartao.toUpperCase() }}</div>
                                                    <div class="card-holder-name"
                                                        v-else-if="cartaoDeCredito.nomeImpressoNoCartao === ''">NOME
                                                        COMPLETO
                                                    </div>
                                                </div>
                                                <div class="box">
                                                    <span>Data Exp.</span>
                                                    <div class="expiration">
                                                        <div class="exp-date"
                                                            v-if="cartaoDeCredito.vencimentoDoCartao !== ''">
                                                            {{ cartaoDeCredito.vencimentoDoCartao }}</div>
                                                        <div class="exp-date"
                                                            v-else-if="cartaoDeCredito.vencimentoDoCartao === ''">MM/AA
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="back"
                                            style="background-image: url(/assets/images/logo-bandeiras/KombiCard2.jpeg);">
                                            <div class="stripe"></div>
                                            <div class="box">
                                                <span>CVV</span>
                                                <div class="cvv-box" v-if="cartaoDeCredito.cvvDoCartao !== ''">{{
                                                    cartaoDeCredito.cvvDoCartao }}</div>
                                                <div class="cvv-box" v-else-if="cartaoDeCredito.cvvDoCartao === ''">###
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 1">
                                                    <img style="height: 40px; width: 80px;"
                                                        src="/assets/images/logo-bandeiras/visa-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 2">
                                                    <img style="height: 35px; width: 50px;"
                                                        src="/assets/images/logo-bandeiras/mastercard-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 3">
                                                    <img style="height: 30px; width: 80px;"
                                                        src="/assets/images/logo-bandeiras/elo-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 4">
                                                    <img style="height: 35px; width: 75px;"
                                                        src="/assets/images/logo-bandeiras/hiper-white.png" alt="">
                                                </div>
                                                <div v-if="pedido.bandeiraCartao == 5">
                                                    <img style="height: 25px; width: 75px;"
                                                        src="/assets/images/logo-bandeiras/amex-white.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <form action="">

                                        <div class="inputValue"
                                            style="margin: 10px 0px 5px 0px; display: flex; padding-right: 10px;">
                                            <div style="padding-right: 20px;">
                                                <div class="">Parcelamento:</div>
                                                <div class="" style="font-weight: 600">
                                                    {{ pedido.formaDePagamento }}
                                                </div>
                                            </div>
                                            <div style="padding-right: 20px;">
                                                <div class="">Total:</div>
                                                <div class="" style="font-weight: 600">
                                                    {{ pedido.totalFormatado }}
                                                </div>
                                            </div>
                                            <div style="padding-right: 20px;">
                                                <div class="">Bandeira:</div>
                                                <div class="" style="font-weight: 600" v-if="pedido.bandeiraCartao == 1">
                                                    <img style="margin-top: -7px;"
                                                        src="/assets/images/logo-bandeiras/Visa.png" width="50" height="15"
                                                        alt="Visa">
                                                </div>
                                                <div class="" style="font-weight: 600" v-if="pedido.bandeiraCartao == 2">
                                                    <img style="margin-top: -5px;"
                                                        src="/assets/images/logo-bandeiras/Master.png" width="50"
                                                        height="15" alt="Master">
                                                </div>
                                                <div class="" style="font-weight: 600" v-if="pedido.bandeiraCartao == 3">
                                                    <img style="margin-top: -5px;"
                                                        src="/assets/images/logo-bandeiras/Elo.png" width="50" height="15"
                                                        alt="Elo">
                                                </div>
                                                <div class="" style="font-weight: 600" v-if="pedido.bandeiraCartao == 4">
                                                    <img style="margin-top: -7px;"
                                                        src="/assets/images/logo-bandeiras/Hipercard.png" width="40"
                                                        height="15" alt="Hiper">
                                                </div>
                                                <div class="" style="font-weight: 600" v-if="pedido.bandeiraCartao == 5">
                                                    <img style="margin-top: -10px;"
                                                        src="/assets/images/logo-bandeiras/Amex.png" width="60" height="30"
                                                        alt="Amex">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="inputBox">
                                            <span for="cardnumber">Número do Cartão</span>
                                            <input id="cardnumber" type="text" pattern="[0-9]*" inputmode="numeric"
                                                v-model="cartaoDeCredito.numeroDoCartao" v-mask="'#### #### #### ####'"
                                                placeholder="5432 0000 0000 0055" class="card-number-input">
                                            <div v-if="!!cartaoDeCredito.numeroDoCartao && !validacaoCartao.numeroCartaoValido"
                                                class=""
                                                style="border-style: solid; margin-left: 0px;  border-width: 1px; border-color: red; align-items: center; width: 100%;">
                                            </div>
                                        </div>
                                        <div class="inputBox">
                                            <span for="name">Nome no Cartão</span>
                                            <input id="name" type="text" maxlength="35"
                                                v-model="cartaoDeCredito.nomeImpressoNoCartao"
                                                placeholder="Ex: Vitor Silva Machado" class="card-holder-input">
                                            <div v-if="!!cartaoDeCredito.nomeImpressoNoCartao && !validacaoCartao.nomeImpressoValido"
                                                class=""
                                                style="border-style: solid; margin-left: 0px;  border-width: 1px; border-color: red; align-items: center; width: 100%;">
                                            </div>

                                        </div>
                                        <div class="flexbox">
                                            <div class="inputBox" style="width: 50%;">
                                                <span for="expirationdate">Mês / Ano Vencimento (MM / AA)</span>
                                                <input id="expirationdate" type="text" pattern="[0-9]*" maxlength="7"
                                                    v-model="cartaoDeCredito.vencimentoDoCartao" inputmode="numeric"
                                                    v-mask="'##/##'" placeholder="Ex: 05/21" class="month-input">
                                                <div v-if="!!cartaoDeCredito.vencimentoDoCartao && !validacaoCartao.vencimentoValido"
                                                    class="wrapper"
                                                    style="border-style: solid; margin-left: 0px;  border-width: 1px; border-color: red; align-items: center; width: 100%;">
                                                </div>
                                            </div>

                                            <div class="inputBox" style="width: 50%;">
                                                <span for="securitycode">Dig. Verificador (CVV)</span>
                                                <input id="securitycode" type="text" maxlength="4" pattern="[0-9]*"
                                                    inputmode="numeric" v-model="cartaoDeCredito.cvvDoCartao" v-mask="'####'"
                                                    placeholder="Ex: 323" class="cvv-input">
                                            </div>
                                        </div>

                                        <div class="col-md-12" style="padding: 0; margin-top: 15px;">
                                            <v-btn v-if="!pagamentoSendoProcessado" @click="finalizarPagamento"
                                                :disabled="!resumoPagamento.botaoFinalizarLiberado" class="submit-btn"
                                                style="width: 100%; margin-top: 15px; margin-bottom: 15px; border-radius: 5px;">
                                                Finalizar
                                            </v-btn>
                                            <div v-else-if="pagamentoSendoProcessado"
                                                style="margin-top: 25px; margin-bottom: 5px; display: flex; justify-content: center;">
                                                <Loader />
                                            </div>
                                        </div>
                                    </form>

                                </div>

                                <!-- <div class="row text-center">
                                    <h5 style="color:black; font-weight: 600;">
                                        Cartão de crédito
                                    </h5>
                                </div>
                                <div class="form-container">
                                    <div class="field-container numero-do-cartao">
                                        <label for="cardnumber">Número do cartão</label>
                                        <input id="cardnumber" type="text" pattern="[0-9]*" inputmode="numeric" v-model="cartaoDeCredito.numeroDoCartao" v-mask="'#### #### #### ####'">
                                        <div v-if="!!cartaoDeCredito.numeroDoCartao && !validacaoCartao.numeroCartaoValido" class="wrapper" style="border-style: solid; border-width: 1px; border-color: red;"></div>
                                    </div>
                                    <div class="field-container validade-do-cartao">
                                        <label for="expirationdate">Validade (MM/AA)</label>
                                        <input id="expirationdate" type="text" pattern="[0-9]*" maxlength="7" v-model="cartaoDeCredito.vencimentoDoCartao" inputmode="numeric" v-mask="'##/##'">
                                        <div v-if="!!cartaoDeCredito.vencimentoDoCartao && !validacaoCartao.vencimentoValido" class="wrapper" style="border-style: solid; border-width: 1px; border-color: red;"></div>
                                    </div>
                                    <div class="field-container cvv-do-cartao">
                                        <label for="securitycode">CVV</label>
                                        <input id="securitycode" type="text" maxlength="3" pattern="[0-9]*" inputmode="numeric" v-model="cartaoDeCredito.cvvDoCartao" v-mask="'###'">
                                    </div>
                                    <div class="field-container">
                                        <label for="name">Nome impresso no cartão</label>
                                        <input id="name" type="text" v-model="cartaoDeCredito.nomeImpressoNoCartao">
                                    </div>
                                    <div class="field-container forma-de-pagamento">
                                        <label for="formaspagamento">Forma de pagamento</label>
                                        <input id="formaspagamento" type="text" :value="pedido.formaDePagamento" readonly style="background-color: whitesmoke;">
                                    </div>
                                </div>
                                <div class="col-md-12" style="text-align:left; color:black; font-weight:300; margin: 5px 0px 0px 0px;">
                                    <div class="row" style="margin: 5px 0px 0px 0px;">
                                        Bandeira do Cartão
                                    </div>
                                    <div class="row" style="text-align:left; margin: 5px 0px 10px 0px;">
                                        <div class="col-md-6">
                                            <img style="margin: 0px 12px 0px 0px;" v-if="pedido.bandeiraCartao == '1'" src="/assets/images/logo-bandeiras/Visa.png" width="100" height="70" alt="Visa">
                                            <img style="margin: 0px 12px 0px 0px;" v-else-if="pedido.bandeiraCartao == '2'" src="/assets/images/logo-bandeiras/Master.png" width="100" height="70" alt="Master">
                                            <img style="margin: 0px 12px 0px 0px;" v-else-if="pedido.bandeiraCartao == '3'" src="/assets/images/logo-bandeiras/Elo.png" width="100" height="70" alt="Elo">
                                            <img style="margin: 0px 12px 0px 0px;" v-else-if="pedido.bandeiraCartao == '4'" src="/assets/images/logo-bandeiras/Hipercard.png" width="100" height="70" alt="Hipercard">
                                            <img style="margin: 0px 12px 0px 0px;" v-else-if="pedido.bandeiraCartao == '5'" src="/assets/images/logo-bandeiras/Amex.png" width="100" height="70" alt="Amex">
    
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
        <div class="container text-center" v-if="!mostrarInfoPedido"
            style="margin-bottom: 50px; font-weight: 600; font-size: 16px;">
            <div v-if="!mostrarInfoPagamento">
                <div class="row">
                    <div>
                        <strong>
                            {{ mensagemStatusCarregamentoPedido }}
                        </strong>
                    </div>
                </div>
            </div>
            <div v-else ref="finalizado">
                <div class="row" style="margin-bottom: 15px;">
                    <img src="/assets/images/icones/icone_concluido.png" width="50" alt="Concluido">
                </div>
                <div class="row">
                    Seu pagamento está sendo processado.
                </div>
                <div class="row">
                    Vamos te enviar um e-mail assim que ele for confirmado.
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { convertNumberToReal } from '../../Utils/formatNumber';
import './OrderPayment.css';
import axios from 'axios';




export default {
    name: "OrderPayment",
    components: {
        //ProductTaxesTooltip,
    },
    mounted() {
        this.getDadosPedido(this.$route.params.codigoLink);

        let pagseguroscript = document.createElement('script')
        pagseguroscript.setAttribute('src', 'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js')
        document.head.appendChild(pagseguroscript)

        setTimeout(() => {
            $('.cvv-input').on("focus", () => {
                $('.front').css("transform", 'perspective(1000px) rotateY(-180deg)');
                $('.back').css("transform", 'perspective(1000px) rotateY(0deg)');
            })

            $('.cvv-input').on("blur", () => {
                $('.front').css("transform", 'perspective(1000px) rotateY(0deg)');
                $('.back').css("transform", 'perspective(1000px) rotateY(-180deg)');
            })
        }, 1000);



    },
    data() {
        return {
            codigoLink: '',
            nomeDoCliente: '',
            cartaoDeCredito: {
                numeroDoCartao: '',
                vencimentoDoCartao: '',
                mesVencimentoDoCartao: '',
                anoVencimentoDoCartao: '',
                cvvDoCartao: '',
                nomeImpressoNoCartao: '',
            },
            validacaoCartao: {
                numeroCartaoValido: false,
                nomeImpressoValido: false,
                vencimentoValido: false,
                cvvValido: false,
            },
            pedido: {
                codigo: 0,
                codigodv: 0,
                nomeDaRevenda: '',
                cidadeUfDoPedido: '',
                dataDoPedido: '',
                nomeDoVendedor: '',
                formaDePagamento: '',
                quantidadeDeParcelas: 0,
                bandeiraCartao: 0,
                subTotalFormatado: '',
                totalFormatado: '',
                totalJuros: 0.00,
                produtosDoPedido: [],
            },
            resumoPagamento: {
                botaoFinalizarLiberado: false,
            },
            encryptedCardErrors: {
                "INVALID_NUMBER": "Número do cartão inválido",
                "INVALID_SECURITY_CODE": "Código de segurança inválido",
                "INVALID_EXPIRATION_MONTH": "Mês de expiração inválido",
                "INVALID_EXPIRATION_YEAR": "Ano de expiração inválido",
                "INVALID_HOLDER": "Nome impresso no cartão inválido",
                "INVALID_PUBLIC_KEY": "Chave pública inválida",
            },
            mostrarInfoPedido: false,
            mostrarInfoPagamento: false,
            mensagemStatusCarregamentoPedido: 'Carregando dados do pedido, por favor aguarde...',
            pagSeguroPaymentStatusEnum: {
                AUTHORIZED: 'Pagamento aguardando autorização.',
                PAID: 'Pagamento efetuado com sucesso.',
                IN_ANALYSIS: 'Pagamento em análise.',
                DECLINED: 'Pagamento negado.',
                CANCELED: 'Pagamento cancelado.',
            },
            pagamentoSendoProcessado: false,
        }
    },
    computed: {
    },
    watch: {
        "cartaoDeCredito.numeroDoCartao"(value) {

            var numCartao = value.replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '');

            if (numCartao.length >= 13) {
                this.validacaoCartao.numeroCartaoValido = true;
                this.liberaFinalizacao();
            }
        },
        "cartaoDeCredito.vencimentoDoCartao"(value) {
            this.validacaoCartao.vencimentoValido = false
            var valueSplited = value.split('/')
            if (valueSplited.length > 1 && valueSplited[0] >= 1 && valueSplited[0] <= 12) {
                const hoje = new Date();
                hoje.setHours(0)
                hoje.setMinutes(0)
                hoje.setSeconds(0)

                this.cartaoDeCredito.mesVencimentoDoCartao = valueSplited[0]
                this.cartaoDeCredito.anoVencimentoDoCartao = valueSplited[1]

                const dataVencimento = new Date('20' + this.cartaoDeCredito.anoVencimentoDoCartao, this.cartaoDeCredito.mesVencimentoDoCartao, hoje.getDate(), 0, 0, 0)
                this.validacaoCartao.vencimentoValido = dataVencimento >= hoje
            }

            this.liberaFinalizacao();
        },
        "cartaoDeCredito.nomeImpressoNoCartao"(value) {
            var valueSplited = value.split(' ')
            this.validacaoCartao.nomeImpressoValido = value.length > 5 && valueSplited.length > 1 && !!valueSplited[1]
            this.liberaFinalizacao();
        },
        "cartaoDeCredito.cvvDoCartao"(value) {
            this.validacaoCartao.cvvValido = !!value && value.length >= 3
            this.liberaFinalizacao();
        },
    },
    methods: {
        converterParaReal: function (number) {
            return convertNumberToReal(number);
        },
        liberaFinalizacao: function () {
            this.resumoPagamento.botaoFinalizarLiberado =
                this.validacaoCartao.numeroCartaoValido &&
                this.validacaoCartao.nomeImpressoValido &&
                this.validacaoCartao.vencimentoValido &&
                this.validacaoCartao.cvvValido;
        },
        getDadosPedido: function (codigoLink) {
            axios
                .get(this.$apiUrl + "Pagamento.svc/GetPaymentInfo/" + codigoLink)
                .then((response) => {
                    if (response.data) {
                        var respostaApi = response.data;
                        this.nomeDoCliente = respostaApi.NomeCliente;
                        this.pedido.codigo = respostaApi.PedidoPagamento.CodigoPedido;
                        this.pedido.codigodv = respostaApi.PedidoPagamento.CodigoDvPedido;
                        this.pedido.nomeDaRevenda = respostaApi.PedidoPagamento.NomeRevenda;
                        this.pedido.nomeDoVendedor = respostaApi.PedidoPagamento.NomeVendedor;
                        this.pedido.formaDePagamento = respostaApi.PedidoPagamento.DescricaoFormaDePagamento;
                        this.pedido.quantidadeDeParcelas = respostaApi.PedidoPagamento.QuantidadeDeParcelas;
                        this.pedido.dataDoPedido = respostaApi.PedidoPagamento.DataFormatada;
                        this.pedido.cidadeUfDoPedido = respostaApi.PedidoPagamento.Cidade + ', ' + respostaApi.PedidoPagamento.Uf;
                        this.pedido.subTotalFormatado = respostaApi.PedidoPagamento.SubTotalFormatado;
                        this.pedido.totalFormatado = respostaApi.PedidoPagamento.TotalFormatado;
                        this.pedido.totalJuros = respostaApi.PedidoPagamento.Juros * respostaApi.PedidoPagamento.SubTotal / 100;
                        this.pedido.bandeiraCartao = respostaApi.PedidoPagamento.BandeiraCartaoCredito;
                        this.pedido.produtosDoPedido = respostaApi.PedidoPagamento.ProdutosPedidoPagamento.map((produto) => {
                            return {
                                codigo: produto.Codigo,
                                codigodv: produto.CodigoDv,
                                img: produto.UrlImagem,
                                descricao: produto.Descricao,
                                quantidade: produto.Quantidade,
                                valorUnitario: produto.ValorUnitario,
                                subGrupo: produto.SubGrupo,
                            }
                        });
                        this.mostrarInfoPedido = true
                    } else {
                        //PEDIDO EM ANALISE
                        this.mostrarInfoPedido = false;
                        this.mostrarInfoPagamento = true;
                    }
                })
                .catch(() => {
                    this.mostrarInfoPedido = false
                    this.mensagemStatusCarregamentoPedido = 'Pedido não encontrado ou não disponível para pagamento.'
                });
        },
        fazerPagamentoCartao: function (card) {

            this.pagamentoSendoProcessado = true;

            axios
                .post(this.$apiUrl + "PagSeguro.svc/SendCardPayment",
                    {
                        codigoPedido: this.pedido.codigo,
                        holderName: this.cartaoDeCredito.nomeImpressoNoCartao,
                        installments: this.pedido.quantidadeDeParcelas,
                        encryptedCard: card.encryptedCard,
                        securityCode: this.cartaoDeCredito.cvvDoCartao
                    }
                ).then((resultado) => {
                    if (resultado.status === 200) {
                        this.mostrarInfoPedido = false;
                        this.mostrarInfoPagamento = true;

                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }, 500);
                    } else {
                        swal({
                            title: this.pagSeguroPaymentStatusEnum[resultado.data],
                            icon: 'error'
                        });
                    }
                }).catch((error) => {
                    console.error(error)
                    swal({
                        title: "Não foi possível concluir seu pagamento. Tente novamente mais tarde.",
                        icon: "error"
                    });
                }).finally(() => {
                    this.pagamentoSendoProcessado = true;
                });
        },
        finalizarPagamento: async function () {
            this.pagamentoSendoProcessado = true;

            const { data } = await axios
                .get(this.$apiUrl + "PagSeguro.svc/GetIntegrationPublicKey");

            if (!!data) {
                var card = PagSeguro.encryptCard({
                    publicKey: data,
                    holder: this.cartaoDeCredito.nomeImpressoNoCartao,
                    number: this.cartaoDeCredito.numeroDoCartao.replace(" ", "").replace(" ", "").replace(" ", "").replace(" ", ""),
                    expMonth: this.cartaoDeCredito.mesVencimentoDoCartao,
                    expYear: '20' + this.cartaoDeCredito.anoVencimentoDoCartao,
                    securityCode: this.cartaoDeCredito.cvvDoCartao
                });

                if (card.hasErrors) {
                    this.pagamentoSendoProcessado = false;
                    if (card.errors[0].code !== "INVALID_PUBLIC_KEY") {
                        if (card.errors[0].code == "INVALID_NUMBER") {
                            this.validacaoCartao.numeroCartaoValido = false;
                        } else if (card.errors[0].code == "INVALID_SECURITY_CODE") {
                            this.validacaoCartao.cvvDoCartao = false;
                        } else if (card.errors[0].code == "INVALID_EXPIRATION_MONTH" || card.errors[0].code == "INVALID_EXPIRATION_YEAR") {
                            this.validacaoCartao.vencimentoValido = false;
                        } else if (card.errors[0].code == "INVALID_HOLDER") {
                            this.validacaoCartao.nomeImpressoValido = false;
                        }

                        swal({
                            title: this.encryptedCardErrors[card.errors[0].code],
                            icon: "warning"
                        });
                    }
                } else {
                    this.pagamentoSendoProcessado = true;
                    axios
                        .post(this.$apiUrl + "PagSeguro.svc/GetBandeira",
                            {
                                codigoPedido: this.pedido.codigo,
                                encryptedCard: card.encryptedCard,
                            }
                        ).then((resultado) => {

                            this.validacaoCartao.numeroCartaoValido = false;

                            if (resultado.status === 200) {
                                const bandeiraCartao = resultado.data;
                                var codBandeira = 0;

                                if (bandeiraCartao === "visa")
                                    codBandeira = 1;
                                else if (bandeiraCartao === "mastercard")
                                    codBandeira = 2;
                                else if (bandeiraCartao === "elo")
                                    codBandeira = 3;
                                else if (bandeiraCartao === "hipercard")
                                    codBandeira = 4;
                                else if (bandeiraCartao === "amex")
                                    codBandeira = 5;

                                this.validacaoCartao.numeroCartaoValido = (bandeiraCartao && (codBandeira == this.pedido.bandeiraCartao))

                                if (!this.validacaoCartao.numeroCartaoValido) {
                                    this.pagamentoSendoProcessado = false;
                                    swal({
                                        title: "É necessário inserir um cartão de crédito com a bandeira correta para o pedido.",
                                        icon: "error"
                                    });
                                    return;
                                }

                                this.fazerPagamentoCartao(card);

                            } else {
                                this.pagamentoSendoProcessado = false;
                                swal({
                                    title: "É necessário inserir um cartão de crédito com a bandeira correta para o pedido.",
                                    icon: "error"
                                });
                            }
                        }).catch((error) => {
                            console.error(error)
                            this.pagamentoSendoProcessado = false;
                            const cartaoInvalido = error.response.data.includes('CARD_CANNOT_BE_STORED')

                            let div = document.createElement('div')
                            div.style.textAlign = 'center'

                            div.innerHTML = cartaoInvalido 
                                ? `Por favor, revise todos os dados inseridos<br>com os dados do cartão e tente novamente.<br><br>                            
                            Se o problema persistir, entre em<br>contato com a operadora do cartão.
                            `
                                : 'Não foi possível verificar seu pagamento. Tente novamente mais tarde.'

                            swal({
                                title: "Erro ao validar Cartão",
                                content: div,
                                icon: 'error'
                            });
                        }).finally(() => {
                        });   
                }
            }
        },
    }
}

</script>
